import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  getSearchApi,
  getSearchApiAcount,
  getSearchApiSearchText,
} from '../../../network/itemList';
import { getPaymentReferences } from '../../../network/PaymentEntry';
import { getParties } from '../../../network/journalEntry';
import { BiSolidShow } from 'react-icons/bi';
import { ModalAppItemDetailsJournal } from '../ModalApp/ModalApp';

const JournalEntryAccountingList = ({
  setDataSourceAccount,
  dataSourceAccount,
  t,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [searchTxt, setSearchTxt] = useState('');
  const [searchTxtAll, setSearchTxtAll] = useState('');
  const [open, setOpen] = useState(false);
  const [selectData, setSelectData] = useState({});
  const { mutate: onGetPaymentReferences } = useMutation({
    mutationKey: [queryKeys.getPaymentReferences],
    mutationFn: ({ id, type }) => getPaymentReferences(id, type),
    onSuccess: (data) => {
      // console.log(data, 'data');
      const newDataSource = [...dataSourceAccount];
      newDataSource[selectedIndex] = {
        ...newDataSource[selectedIndex],
        paymentReferencesName: data?.message?.references,
      };
      setDataSourceAccount(newDataSource);
    },
  });
  const { mutate: onGetParties } = useMutation({
    mutationKey: [queryKeys.getParties],
    mutationFn: (id) => getParties(id),
    onSuccess: (data) => {
      // console.log(data, 'data');
      const newDataSource = [...dataSourceAccount];
      newDataSource[selectedIndex] = {
        ...newDataSource[selectedIndex],
        parties: data?.message?.parties,
      };
      setDataSourceAccount(newDataSource);
    },
  });
  const [count, setCount] = useState(0);

  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCenterSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const { data: account } = useQuery({
    queryKey: [queryKeys.getSearchApiAccount, searchTxt],
    queryFn: () =>
      getSearchApiAcount({ type: 'Account', searchTxt: searchTxt }),
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
    keepPreviousData: true,
  });
  const { data: salesInvoice } = useQuery({
    queryKey: [queryKeys.getSearchApiSalesInvoice, searchTxtAll],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Sales Invoice',
        searchTxt: searchTxtAll,
      }),
    enabled: searchTxtAll?.length >= 3 || searchTxtAll?.length === 0,
    keepPreviousData: true,
  });
  const { data: salesOrder } = useQuery({
    queryKey: [queryKeys.getSearchApiSalesOrder, searchTxtAll],
    queryFn: () =>
      getSearchApiSearchText({ type: 'Sales Order', searchTxt: searchTxtAll }),
    enabled: searchTxtAll?.length >= 3 || searchTxtAll?.length === 0,
    keepPreviousData: true,
  });
  // const { data: duning } = useQuery({
  //   queryKey: [queryKeys.getSearchApiDuning, searchTxtAll],
  //   queryFn: () =>
  //     getSearchApiSearchText({ type: 'Duning', searchTxt: searchTxtAll }),
  //   enabled: searchTxtAll?.length >= 3 || searchTxtAll?.length === 0,
  //   keepPreviousData: true,
  // });
  const duning = [];
  const { data: journalEntry } = useQuery({
    queryKey: [queryKeys.getSearchApiJournalEntry, searchTxtAll],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Journal Entry',
        searchTxt: searchTxtAll,
      }),
    enabled: searchTxtAll?.length >= 3 || searchTxtAll?.length === 0,
    keepPreviousData: true,
  });
  const handleDetails = (key) => {
    const row = dataSourceAccount.find((item) => item?.key === key);
    if (row) {
      setSelectData({
        ...row,
      });
      setDataSourceAccount({
        ...row,
      });
      setDataSourceAccount(
        dataSourceAccount.map((item) => ({
          ...item,
        }))
      );
      setOpen(true);
      console.log('Row details:', row);
    }
  };
  const columns = [
    {
      title: t.Account,
      dataIndex: 'account',
      render: (text, record, index) => (
        <Select
          placeholder={t.Account}
          value={record?.account}
          style={{ width: '200px' }}
          showSearch
          allowClear
          onClear={() => {
            setSearchTxt('');
          }}
          filterOption={false}
          onSearch={(value) => {
            setSearchTxt(value);
          }}
          popupMatchSelectWidth={false}
          options={account?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          onChange={(value, option) => {
            console.log(option, 'option');
            setSearchTxt('');
            const newDataSource = [...dataSourceAccount];
            newDataSource[index] = {
              ...newDataSource[index],
              account: value,
            };
            setDataSourceAccount(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.PartyType,
      dataIndex: 'party_type',
      render: (text, record, index) => (
        <Select
          placeholder={t.PartyType}
          value={record?.party_type}
          style={{ width: '200px' }}
          popupMatchSelectWidth={false}
          options={[
            { value: 'Customer', label: t.Customer },
            {
              value: 'Supplier',
              label: t.Supplier,
            },
            {
              value: 'Employee',
              label: t.Employee,
            },
            {
              value: 'Shareholder',
              label: t.Shareholder,
            },
          ]}
          onChange={(value, option) => {
            // console.log(option, 'option');
            setSelectedIndex(index);
            onGetParties(value);
            const newDataSource = [...dataSourceAccount];
            newDataSource[index] = {
              ...newDataSource[index],
              party_type: value,
            };
            setDataSourceAccount(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.Party,
      dataIndex: 'party',
      render: (text, record, index) => (
        <Select
          placeholder={t.Party}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '')
              .toLocaleLowerCase()
              .includes(input.toLocaleLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '')
              .toLowerCase()
              .localeCompare((optionB?.label ?? '').toLowerCase())
          }
          value={record?.party}
          style={{ width: '200px' }}
          popupMatchSelectWidth={false}
          options={
            record?.parties?.length
              ? record?.parties?.map((item) => ({
                  value: item?.name,
                  label: item?.name,
                }))
              : []
          }
          onChange={(value) => {
            // console.log(option, 'option');
            if (record?.reference_type) {
              onGetPaymentReferences({
                id: value,
                type: record?.reference_type,
              });
            }
            const newDataSource = [...dataSourceAccount];
            newDataSource[index] = {
              ...newDataSource[index],
              party: value,
            };
            setDataSourceAccount(newDataSource);
          }}
        />
      ),
    },
    // {
    //   title: t.costCenter,
    //   dataIndex: 'cost_center',
    //   render: (text, record, index) => (
    //     <Select
    //       placeholder={t.costCenter}
    //       value={record?.cost_center}
    //       style={{ width: '200px' }}
    //       popupMatchSelectWidth={false}
    //       showSearch
    //       optionFilterProp="children"
    //       filterOption={(input, option) =>
    //         (option?.label ?? '')
    //           .toLocaleLowerCase()
    //           .includes(input.toLocaleLowerCase())
    //       }
    //       filterSort={(optionA, optionB) =>
    //         (optionA?.label ?? '')
    //           .toLowerCase()
    //           .localeCompare((optionB?.label ?? '').toLowerCase())
    //       }
    //       options={costCenters?.message?.map((user) => ({
    //         value: user.value,
    //         label: user.value,
    //       }))}
    //       onChange={(value) => {
    //         // console.log(option, 'option');
    //         const newDataSource = [...dataSourceAccount];
    //         newDataSource[index] = {
    //           ...newDataSource[index],
    //           cost_center: value,
    //         };
    //         setDataSourceAccount(newDataSource);
    //       }}
    //     />
    //   ),
    // },
    {
      title: t.Debit,
      dataIndex: 'debit',
      render: (text, record, index) => (
        <Input
          placeholder={t.Debit}
          type="number"
          value={record.debit}
          style={{ width: '200px' }}
          onChange={(e) => {
            const newDataSource = [...dataSourceAccount];
            newDataSource[index] = {
              ...newDataSource[index],
              debit: e.target.value,
            };
            setDataSourceAccount(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.Credit,
      dataIndex: 'credit',
      render: (text, record, index) => (
        <Input
          placeholder={t.Credit}
          type="number"
          value={record.credit}
          style={{ width: '200px' }}
          onChange={(e) => {
            const newDataSource = [...dataSourceAccount];
            newDataSource[index] = {
              ...newDataSource[index],
              credit: e.target.value,
            };
            setDataSourceAccount(newDataSource);
          }}
        />
      ),
    },
    // {
    //   title: t.type,
    //   dataIndex: 'reference_type',
    //   render: (text, record, index) => (
    //     <Select
    //       placeholder={t.type}
    //       value={record?.reference_type}
    //       style={{ width: '200px' }}
    //       popupMatchSelectWidth={false}
    //       options={[
    //         { value: 'Sales Invoice', label: t.salesInvoice },
    //         {
    //           value: 'Sales Order',
    //           label: t.SalesOrder,
    //         },
    //         {
    //           value: 'Duning',
    //           label: t.Duning,
    //         },
    //         {
    //           value: 'Journal Entry',
    //           label: t.JournalEntry,
    //         },
    //       ]}
    //       onChange={(value, option) => {
    //         // if (record?.party) {
    //         //   onGetPaymentReferences({ id: record?.party, type: value });
    //         // }
    //         setSearchTxtAll('');
    //         const newDataSource = [...dataSourceAccount];
    //         newDataSource[index] = {
    //           ...newDataSource[index],
    //           reference_type: value,
    //         };
    //         setDataSourceAccount(newDataSource);
    //       }}
    //     />
    //   ),
    // },
    // {
    //   title: t.Name,
    //   dataIndex: 'reference_name',
    //   render: (text, record, index) => (
    //     <Select
    //       placeholder={t.Name}
    //       value={record?.reference_name}
    //       style={{ width: '200px' }}
    //       showSearch
    //       optionFilterProp="children"
    //       filterOption={(input, option) =>
    //         (option?.label ?? '')
    //           .toLocaleLowerCase()
    //           .includes(input.toLocaleLowerCase())
    //       }
    //       filterSort={(optionA, optionB) =>
    //         (optionA?.label ?? '')
    //           .toLowerCase()
    //           .localeCompare((optionB?.label ?? '').toLowerCase())
    //       }
    //       popupMatchSelectWidth={false}
    //       // options={record?.paymentReferencesName?.length ? record?.paymentReferencesName?.map((account) => ({
    //       //   value: account?.name,
    //       //   label: account?.name,
    //       //   option: account,
    //       // })) : []}
    //       options={
    //         dataSourceAccount[index]?.reference_type === 'Journal Entry'
    //           ? journalEntry?.message?.map((user) => ({
    //               value: user.value,
    //               label: user.value,
    //             }))
    //           : dataSourceAccount[index]?.reference_type === 'Sales Invoice'
    //           ? salesInvoice?.message?.map((user) => ({
    //               value: user.value,
    //               label: user.value,
    //             }))
    //           : dataSourceAccount[index]?.reference_type === 'Sales Order'
    //           ? salesOrder?.message?.map((user) => ({
    //               value: user.value,
    //               label: user.value,
    //             }))
    //           : duning?.message?.map((user) => ({
    //               value: user.value,
    //               label: user.value,
    //             }))
    //       }
    //       onChange={(value) => {
    //         // console.log(option, 'option');
    //         setSearchTxtAll('');
    //         const newDataSource = [...dataSourceAccount];
    //         newDataSource[index] = {
    //           ...newDataSource[index],
    //           reference_name: value,
    //         };
    //         setDataSourceAccount(newDataSource);
    //       }}
    //     />
    //   ),
    // },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <div className="flex items-center gap-1">
          <Button
            type="primary"
            // icon={<MdEdit />}
            icon={<BiSolidShow />}
            size="small"
            onClick={() => {
              setSelectedIndex(index);
              handleDetails(record.key);
            }}
          />
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      amount: 0,
    };
    setDataSourceAccount([...dataSourceAccount, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceAccount.filter((item) => item.key !== key);
    setDataSourceAccount(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceAccount}
        columns={columns}
        pagination={{ hideOnSinglePage: true }}
        scroll={{ x: 'max-content' }}
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
      <ModalAppItemDetailsJournal
        setDataSource={setDataSourceAccount}
        dataSource={dataSourceAccount}
        selectedIndex={selectedIndex}
        open={open}
        setOpen={setOpen}
        t={t}
        selectData={selectData}
      />
    </Card>
  );
};

export default JournalEntryAccountingList;
